

const CatalogTable = ({ rows }) => {
    if (!rows || rows.length === 0) return null;

    return (
        <table className="table table-light table-catalog-items mt-1 p-0">
            <thead>
            <tr>
                <th>Товар</th>
                <th>Витрачено</th>
                <th>Кліки</th>
                <th>Покази</th>
            </tr>
            </thead>
            <tbody>
            {rows.map((row, i) => (
                <tr key={i}>
                    <td>{row.product_name}</td>
                    <td>${row.spend.toFixed(2)}</td>
                    <td>{row.clicks}</td>
                    <td>{row.impressions}</td>
                </tr>
            ))}
            </tbody>
        </table>
    );
};

export default CatalogTable;